import Layout from "../layouts/layout";
import styles from "../styles/_screens/constraintsList.module.scss";

const ConstraintsList = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <h1>List of Constraints</h1>

        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                {/* delete */}
                <th></th>
                {/* ticket name */}
                <th>Ticket Name</th>
                {/* start date */}
                <th>Start Date</th>
                {/* end date */}
                <th>End Date</th>
                {/* type */}
                <th>Type</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Delete</td>
                <td>Entrance fees to the Ben-Gurion barracks site</td>
                <td>21/12/2022</td>
                <td>31/12/2022</td>
                <td>Change of operating hours - main attraction</td>
              </tr>
              <tr>
                <td>Delete</td>
                <td>Entrance fees to the Ben-Gurion barracks site</td>
                <td>21/12/2022</td>
                <td>31/12/2022</td>
                <td>Change of operating hours - main attraction</td>
              </tr>
              <tr>
                <td>Delete</td>
                <td>Entrance fees to the Ben-Gurion barracks site</td>
                <td>21/12/2022</td>
                <td>31/12/2022</td>
                <td>Change of operating hours - main attraction</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};

export default ConstraintsList;
